// =============================================================================
// admin-api.js（[JTB-ADMIN-API-SLIM] 2026-10-21 整理版）
//
// ファイル名は読み込み元（layout/theme.liquid・layout/top-page.liquid・layout/login.liquid・
// sections/advanced-search-sort.liquid・sections/main-register-success.liquid）を変更しないために据え置き。
// 中身は Storefront API 用の2つだけを残している。
//
// ■ 残したもの（テーマ内で使用中）
//   - callGraphQLStoreFront … assets/util.js（コレクション商品一覧）、sections/advanced-search-sort.liquid
//   - getProducts           … sections/advanced-search-sort.liquid（検索結果）
//
// ■ 削除したもの（テーマ内で未使用。旧版は Git／テーマのバックアップを参照）
//   - callGraphQL … Admin API（X-Shopify-Access-Token）を呼べる汎用関数。
//                   ブラウザから Admin API を呼ぶ作りはトークン漏えいにつながるため削除
//   - fetchCustomerDetails / getCustomerIdFromURL … 上記 Admin API を使う顧客取得（呼び出し元はコメントアウト済み）
//   - Admin API 用クエリ・ミューテーション：customer / customerCreate / customerUpdate /
//     customerEmailMarketingConsentUpdate / customerGenerateAccountActivationUrl /
//     customerSendAccountInviteEmail / updateCustomerMetafields / getCollections /
//     getMetaobjectEntries / getProductsByCollection
//
// ※ Admin API が必要な処理は、ブラウザではなくサーバー側（Lambda／アプリプロキシ等）で実装すること
//
// [JTB-ADMIN-API-ONCE] このファイルは layout/theme.liquid と sections/advanced-search-sort.liquid 等で
//   同じページに2回読み込まれることがある。トップレベルで const を宣言すると2回目の読み込みで
//   「Identifier '…' has already been declared」の SyntaxError になるため、全体を即時関数で囲み、
//   2回目以降は何もしない。関数・クエリは window に公開する（util.js 等からは従来どおり名前で呼べる）
// =============================================================================

(function () {
  if (typeof window === 'undefined') return;
  if (window.__jtbAdminApiLoaded) return; // 2回目以降の読み込みでは何もしない
  window.__jtbAdminApiLoaded = true;

  // Storefront API：商品検索（advanced-search-sort.liquid の検索結果で使用）
  // [JTB-PICKUP-LABEL] product_pickuplabel メタフィールドを追加
  const getProducts = `
    query search($query: String!, $first: Int!, $after: String, $sortKey: SearchSortKeys, $types: [SearchType!], $productFilters: [ProductFilter!]) {
      search(
        query: $query,
        first: $first,
        after: $after,
        sortKey: $sortKey,
        types: $types,
        productFilters: $productFilters
      ) {
        edges {
          node {
            ... on Product {
              id
              title
              handle
              createdAt
              publishedAt
              productType
              vendor
              description
              tags
              featuredImage {
                url
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
              metafields(identifiers: [
                {namespace: "custom", key: "prefecture"},
                {namespace: "custom", key: "choose_a_premium_experience"},
                {namespace: "custom", key: "choose_from_rooms"},
                {namespace: "custom", key: "choose_from_meals"},
                {namespace: "custom", key: "product_pickuplabel"}
              ]) {
                id
                key
                value
                type
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        productFilters {
          label
          values {
            label
            count
            input
          }
        }
        totalCount
      }
    }
  `;

  // Storefront API を呼ぶ（Storefront 用トークンのみ。Admin API は呼べない）
  async function callGraphQLStoreFront(method, query, variables, shopifyAccessToken, shopifyApiUrl) {
    const config = {
      storefront: {
        url: shopifyApiUrl,
        tokenHeader: 'X-Shopify-Storefront-Access-Token',
        token: shopifyAccessToken,
      },
    };

    const { url, tokenHeader, token } = config['storefront'];

    const response = await fetch(url, {
      method: method || 'POST',
      headers: {
        'Content-Type': 'application/json',
        [tokenHeader]: token,
      },
      body: JSON.stringify({ query, variables }),
      credentials: 'include',
    });

    const data = await response.json();
    if (!response.ok) {
      const message = data && data.errors ? data.errors.map((e) => e.message).join(', ') : response.statusText;
      throw new Error(message || 'Request failed');
    }
    if (data.errors && data.errors.length) {
      throw new Error(data.errors.map((e) => e.message).join(', '));
    }
    return data;
  }

  window.getProducts = getProducts;
  window.callGraphQLStoreFront = callGraphQLStoreFront;
})();
